import { TopConquerorsCard } from "./top-conquerors-card";
import { useDominationData } from "./use-domination-data";
import { WorldDominationCard } from "./world-domination-card";

export const WorldDominationRow = () => {
  const state = useDominationData();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 gap-3">
      <WorldDominationCard state={state} className="lg:col-span-3" />
      <TopConquerorsCard state={state} className="lg:col-span-2" />
    </div>
  );
};
